module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-premium-d15860b452ef8060698ea55bcbbbc3d1.jpg";